import Term from "../Term";
import TermCell from "./TermCell";
import { QuestionType } from "../../settings/model/QuestionType";
import { PronunciationPosition } from "../../settings/model/PronunciationPosition";
import { Virtuoso } from "react-virtuoso";
import LearningResultCell from "../../learning/view/LearningResultCell";
import { useReadingSettings } from "../../common/util/chineseCharacterMode";
import { TermSentenceWithStringValue } from "../../sentence/model/Sentence";

interface TermListGridProps {
  terms: Term[];
  handleOnClick: (term: Term, isSelectionMode: boolean) => void;
  handleOnClickMarkButton: (term: Term) => void;
  handleOnClickLevelButton: (term: Term) => void;
  handleOnClickMoreButton: (
    event: React.MouseEvent<HTMLDivElement>,
    term: Term
  ) => void;
  handleOnClickGenerateSentenceButton: (term: Term) => void;
  handleOnClickSentenceLanguageButton: (term: Term) => void;
  handleOnClickMoreSentenceButton: (term: Term) => void;
  handleOnClickSentenceMoreButton: (
    event: React.MouseEvent<HTMLDivElement>,
    item: TermSentenceWithStringValue
  ) => void;
  config: {
    style: "list" | "learningResult" | "learnedTerms" | "sheetList";
    questionType: QuestionType;
    pronunciationPosition: PronunciationPosition;
    isSelectionMode: boolean;
    isShowDetailMode?: boolean;
    hideMoreButton?: boolean;
  };
}

export default function TermListGrid(props: TermListGridProps) {
  const { chineseCharacterMode } = useReadingSettings();
  if (props.config.style === "list") {
    return (
      <Virtuoso
        lang={chineseCharacterMode === "japanese" ? "ja" : navigator?.language}
        useWindowScroll
        totalCount={props.terms.length}
        itemContent={(index) => (
          <TermCell
            key={index}
            term={props.terms[index]}
            handleOnClick={() =>
              props.handleOnClick(
                props.terms[index],
                props.config.isSelectionMode
              )
            }
            handleOnClickMarkButton={() =>
              props.handleOnClickMarkButton(props.terms[index])
            }
            handleOnClickLevelButton={() =>
              props.handleOnClickLevelButton(props.terms[index])
            }
            handleOnClickMoreButton={(event) =>
              props.handleOnClickMoreButton(event, props.terms[index])
            }
            handleOnClickGenerateSentenceButton={() =>
              props.handleOnClickGenerateSentenceButton(props.terms[index])
            }
            handleOnClickSentenceLanguageButton={() =>
              props.handleOnClickSentenceLanguageButton(props.terms[index])
            }
            handleOnClickMoreSentenceButton={() =>
              props.handleOnClickMoreSentenceButton(props.terms[index])
            }
            handleOnClickSentenceMoreButton={
              props.handleOnClickSentenceMoreButton
            }
            config={props.config}
          />
        )}
      />
    );
  } else if (props.config.style === "sheetList") {
    return (
      <Virtuoso
        lang={chineseCharacterMode === "japanese" ? "ja" : navigator?.language}
        totalCount={props.terms.length}
        itemContent={(index) => (
          <TermCell
            key={index}
            term={props.terms[index]}
            handleOnClick={() =>
              props.handleOnClick(
                props.terms[index],
                props.config.isSelectionMode
              )
            }
            handleOnClickMarkButton={() =>
              props.handleOnClickMarkButton(props.terms[index])
            }
            handleOnClickLevelButton={() =>
              props.handleOnClickLevelButton(props.terms[index])
            }
            handleOnClickMoreButton={(event) =>
              props.handleOnClickMoreButton(event, props.terms[index])
            }
            handleOnClickGenerateSentenceButton={() =>
              props.handleOnClickGenerateSentenceButton(props.terms[index])
            }
            handleOnClickSentenceLanguageButton={() =>
              props.handleOnClickSentenceLanguageButton(props.terms[index])
            }
            handleOnClickMoreSentenceButton={() =>
              props.handleOnClickMoreSentenceButton(props.terms[index])
            }
            handleOnClickSentenceMoreButton={
              props.handleOnClickSentenceMoreButton
            }
            config={props.config}
          />
        )}
      />
    );
  } else if (props.config.style === "learnedTerms") {
    return (
      <Virtuoso
        lang={chineseCharacterMode === "japanese" ? "ja" : navigator?.language}
        totalCount={props.terms.length}
        itemContent={(index) => (
          <LearningResultCell
            key={index}
            term={props.terms[index]}
            config={{
              firstShow: props.config.questionType,
            }}
            handleOnClickMoreButton={(event) =>
              props.handleOnClickMoreButton(event, props.terms[index])
            }
            handleOnClickMarkButton={() => {
              props.handleOnClickMarkButton(props.terms[index]);
            }}
            handleOnClickLevelButton={() =>
              props.handleOnClickLevelButton(props.terms[index])
            }
            handleOnClickGenerateSentenceButton={() =>
              props.handleOnClickGenerateSentenceButton(props.terms[index])
            }
            handleOnClickSentenceLanguageButton={() =>
              props.handleOnClickSentenceLanguageButton(props.terms[index])
            }
            handleOnClickMoreSentenceButton={() =>
              props.handleOnClickMoreSentenceButton(props.terms[index])
            }
            handleOnClickSentenceMoreButton={
              props.handleOnClickSentenceMoreButton
            }
          />
        )}
      />
    );
  } else {
    return (
      <Virtuoso
        useWindowScroll
        lang={chineseCharacterMode === "japanese" ? "ja" : navigator?.language}
        totalCount={props.terms.length}
        itemContent={(index) => (
          <LearningResultCell
            key={index}
            term={props.terms[index]}
            config={{
              firstShow: props.config.questionType,
            }}
            handleOnClickMoreButton={(event) =>
              props.handleOnClickMoreButton(event, props.terms[index])
            }
            handleOnClickMarkButton={() => {
              props.handleOnClickMarkButton(props.terms[index]);
            }}
            handleOnClickLevelButton={() =>
              props.handleOnClickLevelButton(props.terms[index])
            }
            handleOnClickGenerateSentenceButton={() =>
              props.handleOnClickGenerateSentenceButton(props.terms[index])
            }
            handleOnClickSentenceLanguageButton={() =>
              props.handleOnClickSentenceLanguageButton(props.terms[index])
            }
            handleOnClickMoreSentenceButton={() =>
              props.handleOnClickMoreSentenceButton(props.terms[index])
            }
            handleOnClickSentenceMoreButton={
              props.handleOnClickSentenceMoreButton
            }
          />
        )}
      />
    );
  }
}
